import { createAsyncThunk, createEntityAdapter, createSlice } from '@reduxjs/toolkit';
import { MailSubscription, ReduxEntity } from 'Douleutaras/types';
import { makeRequest } from 'Douleutaras/services/apiClient';
import { RootState } from 'Douleutaras/redux/store';

const MAIL_SUBSCRIPTION_ENDPOINT = 'api/public/mail_subscription';

const pushNotificationsAdapter = createEntityAdapter<MailSubscription>({
  selectId: notification => notification.id
});

export const getPushNotifications = createAsyncThunk(
  'user/pushNotifications/get',
  async (arg = undefined, api) => {
    const response = await makeRequest(
      `${MAIL_SUBSCRIPTION_ENDPOINT}/`,
      { method: 'GET' }
    )(api);

    return response.data;
  }
);

export const updatePushNotification = createAsyncThunk(
  'user/pushNotifications/update',
  async (data: Pick<MailSubscription, 'id' | 'push'> & { template: string }, api) => {
    let response;
    const isNull = data.id === null;
    const endpoint = isNull ? '' : `${data.id}/`;

    response = await makeRequest(
      `${MAIL_SUBSCRIPTION_ENDPOINT}/${endpoint}`,
      {
        method: isNull ? 'POST' : 'PATCH',
        body: isNull ? {
          ...data,
          email: true,
          sms: true
        } : {
          id: data.id,
          push: data.push
        }
      }
    )(api);
  }
);

export const pushNotificationsSlice = createSlice({
  name: 'pushNotifications',
  initialState: pushNotificationsAdapter.getInitialState({
    loading: false,
    error: false,
    entities: []
  } as ReduxEntity<MailSubscription>),
  reducers: {},
  extraReducers: builder => {
    builder.addCase(getPushNotifications.fulfilled, (state, action) => {
      state.entities = action.payload || [];
    });
  }
});

export const pushNotificationsSelector = pushNotificationsAdapter.getSelectors((state: RootState) => state.pushNotifications);
